import { SubmitHandler, useForm } from "react-hook-form";
import { Grid, Typography } from "@mui/material";
import React from "react";

import { useEffect } from "react";
import FormFields from "../FormFields/FormFields";
import MuiButton from "../MuiButton";
import { IFormField } from "../../../models/app";

interface Props {
  fields: IFormField[];
  buttonText?: string;
  defaultValues?: any;
  dir?: "rtl" | "ltr" | undefined;
  cb?: (data: any) => void;
  onChange?: (name: string, value: any) => void;
  onBlur?: (name: string, value: any) => void;
  validations?: any;
  reset?: Boolean;
  isHorizontal?: Boolean;
}

const Form: React.FC<Props> = ({
  fields,
  buttonText,
  defaultValues,
  dir,
  cb,
  onChange,
  onBlur,
  validations,
  reset,
  isHorizontal,
}) => {
  const {
    control,
    handleSubmit,
    watch,
    setValue,
    reset: _reset,
    register,
    formState: { errors, isSubmitting, isValid },
  } = useForm<any>({ defaultValues });

  const onSubmit: SubmitHandler<any> = async (data: any) => cb && cb(data);

  useEffect(() => {
    if (reset) {
      _reset(defaultValues);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reset]);

  return (
    <>
      <form dir={dir}>
        {fields.length > 0 && (
          <Grid container width={"100%"} spacing={2}>
            {fields.map((field: any) => (
              <>
                <Grid key={field.name} item xs={12} spacing={2}>
                  {!field.isEditor && (
                    <FormFields
                      {...field}
                      control={control}
                      errors={errors}
                      watch={watch}
                      setValue={setValue}
                      register={register}
                      onChange={(e: any) => {
                        onChange &&
                          onChange(
                            field.name,
                            !e ? null : e.target?.value! || e?.value! || e!
                          );
                      }}
                      onBlur={(e: any) => {
                        onBlur &&
                          onBlur(
                            field.name,
                            !e ? null : e.target?.value! || e?.value! || e!
                          );
                      }}
                    />
                  )}
                  {!field.hidden && field.helperText && (
                    <Typography
                      variant="subtitle2"
                      style={{ marginBlock: "5px" }}
                    >
                      {field.helperText}
                    </Typography>
                  )}
                </Grid>

              </>
            ))}
          </Grid>
        )}
        {buttonText && (
          <Grid container justifyContent="center" sx={{ py: 4 }}>
            <MuiButton
              size="large"
              variant="contained"
              type="submit"
              disabled={
                isSubmitting || Object.keys(errors).length > 0 || !isValid
              }
              sx={{ minWidth: 184 }}
              onClick={handleSubmit(onSubmit)}
            >
              {buttonText}
            </MuiButton>
          </Grid>
        )}
      </form>
    </>
  );
};

export default Form;
